import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementUI from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init({
    offset: 20,
    delay: 300, // values from 0 to 3000, with step 50ms
    duration: 800 // values from 0 to 3000, with step 50ms
});
let HomeInfo = {
    Tel: '03-6874-5334',
    Fax: '',
    PostCode: '101-0021',
    Email: 'info@aum-info.co.jp',
    Address: '東京都千代田区外神田2丁目2-17',
    Building: '共同ビル(万世)4F 47',
    CompanyName: 'AUM株式会社',
    CompanyNo: '（略称：AUM）',
    Representative: '周　鵬（シュウ　ホウ）',
    Capital: '１,０００',
    Banks: '三菱UFJ銀行、　住信SBIネット銀行',
    CreateDate: '2018年03月01日',
    YearSell: '1.9億円 （2021年3月期）',
    HakenNo:  '派13-317649',
    CTO: '姜 再歓',
    MapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.0802384466647!2d139.76543531612046!3d35.69964303656746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c1bf6530755%3A0xdccf7ae5cc63b7c3!2z44CSMTAxLTAwMjEgVG9reW8sIENoaXlvZGEgQ2l0eSwgU290b2thbmRhLCAyLWNoxY1tZeKIkjLiiJIxNyDllpzliqnjgYrojLbjga7msLTjg5Pjg6s!5e0!3m2!1szh-CN!2sjp!4v1641277270543!5m2!1szh-CN!2sjp',
}
const app = createApp(App)
    // load 
$.ajax({
    type: "GET",
    url: "/api/company.php",
    dataType: "json",
    success: (res) => {
        HomeInfo = res
        let url = document.location
        if (url.protocol !== 'https:') {
            window.location.href = 'https://' + url.host + url.pathname
        }
        app.config.globalProperties.HomeInfo = res
        app.use(router).use(ElementUI).use(HomeInfo).use(AOS).mount('#app')
    },
    error: (res) => {
        app.config.globalProperties.HomeInfo = HomeInfo
        app.use(router).use(ElementUI).use(HomeInfo).use(AOS).mount('#app')
    },
});